export const LIMIT = 5;
export const QUALIFIED_STATUS = 'qualified';
